<template lang="pug">
v-dialog(v-model="dialog" width="550" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.ml-10(small color="green" dark v-bind="attrs" v-on="on")
            v-icon(small left) mdi-eye-settings
            | QR Code
    v-card
        v-card-title Generated QR Code
        v-card-text
            center(v-if="dialog")
                img(ref="image")
            v-divider.my-4
            div.px-2
                v-text-field(
                    :value="redemptionUrl"
                    label="Redemption Link"
                    readonly
                    outlined
                    dense
                    hide-details
                    @click="selectUrl"
                )
                    template(v-slot:append)
                        v-btn(
                            icon
                            small
                            @click="copyUrl"
                            :color="copied ? 'success' : 'primary'"
                        )
                            v-icon(small) {{ copied ? 'mdi-check' : 'mdi-content-copy' }}
                v-alert.mt-3(
                    dense
                    text
                    type="info"
                    icon="mdi-information"
                )
                    small Share this link to let users redeem the badge without scanning. Non-app users will be directed to the app store.
        v-card-actions
            v-spacer
            v-btn(small color="red" text @click="dialog = false") Close
</template>


<script>
import QrCodeWithLogo from "qrcode-with-logos";

export default {
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            dialog: false,
            copied: false
        };
    },
    computed: {
        redemptionUrl() {
            // Use short tracking URL that records analytics before redirecting
            return `https://api.breakinghits.com/qr/${this.item.code}`;
        },
        actualPromoUrl() {
            // Original direct URL (for reference)
            return `https://www.breakinghits.com/promo/${this.item.code}`;
        }
    },
    methods: {
        selectUrl(event) {
            event.target.select();
        },
        async copyUrl() {
            try {
                await navigator.clipboard.writeText(this.redemptionUrl);
                this.copied = true;
                setTimeout(() => {
                    this.copied = false;
                }, 2000);
            } catch (err) {
                // Fallback for older browsers
                const textField = document.createElement('textarea');
                textField.innerText = this.redemptionUrl;
                document.body.appendChild(textField);
                textField.select();
                document.execCommand('copy');
                textField.remove();
                this.copied = true;
                setTimeout(() => {
                    this.copied = false;
                }, 2000);
            }
        }
    },
    watch: {
        dialog(val) {
            if(val) {
                setTimeout(async () => {
                    try {
                        const checkLink = url => {
                            return fetch(url).then(result => {
                                return result.ok;
                            }).catch((err) => false);
                        };
                        const logo = (await checkLink(this.item.icon) && {
                                src: this.item.icon
                        }) || undefined;
                        new QrCodeWithLogo({
                            // canvas: document.getElementById("canvas"),
                            content: this.redemptionUrl,
                            width: 380,
                            download: false,
                            image: this.$refs.image,
                            logo: logo
                        }).toImage();
                    } catch(err) {
                        console.log(err)
                    }
                }, 100);
            }
        }
    },
    mounted() {
        
        
    }
}
</script>
